import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import RootNavigation from "./navigations/RootNavigation";
import { Provider } from "react-redux";
import { store } from "./store";
import ErrorBoundary from "./components/Common/ErrorBoundary";
import { NetworkProvider } from "./NetworkContext";

const App = () => {
  return (
    <BrowserRouter>
      <RootNavigation />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <NetworkProvider>
        <App />
      </NetworkProvider>
    </ErrorBoundary>
  </Provider>,
);

// Unregister service worker to avoid stale cached JS after deploys
// (blank page + "Unexpected token '<'" when old main.*.js is missing).
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
